import React, { useState } from 'react';
import classNames from 'classnames';

const SearchFilterCheckboxes = ({ selectedGroup, groupSelected, searchFilter, closeModal }) => {
  const [groupSelectedState] = useState(groupSelected);
  const [searchFilterState, setSearchFilterState] = useState(searchFilter);

  // Get buckets from the API response
  const getBuckets = () => {
    if (!selectedGroup || !selectedGroup.filtered) {
      return [];
    }
    
    const filterData = selectedGroup.filtered[groupSelectedState];
    return filterData?.buckets || [];
  };

  const getTotalCount = () => {
    return selectedGroup?.filtered?.doc_count || 0;
  };

  const checkboxOnChange = (selected) => {
    let newGroup;
    if (isGroupChecked(String(selected))) {
      newGroup = searchFilterState[groupSelectedState].filter(item => item !== String(selected));
    } else {
      newGroup = [...(searchFilterState[groupSelectedState] || []), String(selected)];
    }
    setSearchFilterState(prevState => ({
      ...prevState,
      [groupSelectedState]: newGroup.sort(),
    }));
  };

  const handleModalClose = () => {
    closeModal(searchFilterState);
  };

  const handleSelectAllClick = () => {
    setSearchFilterState(prevState => ({
      ...prevState,
      [groupSelectedState]: [],
    }));
  };

  const isGroupChecked = (key) => {
    const currentGroup = searchFilterState[groupSelectedState] || [];
    return currentGroup.includes(String(key));
  };

  const printGroup = (key) => {
    return key;
  };

  const getModalTitle = () => {
    switch (groupSelectedState) {
      case 'exhibitor_type':
        return 'Exhibitor Type';
      case 'tags':
        return 'Tags';
      default:
        return groupSelectedState.charAt(0).toUpperCase() + groupSelectedState.slice(1);
    }
  };

  const buckets = getBuckets();
  const totalCount = getTotalCount();
  const modalTitle = getModalTitle();

  return (
    <div>
      {/* Render modal title */}
      <div className="event-finder-modal-title">
        <h2 style={{ color: '#000', fontSize: '22px', textAlign: 'center', marginTop: '15px' }}>
          {modalTitle}
        </h2>
      </div>

      {/* Render checkboxes */}
      <div className="modal-filters">
        <div
          className={classNames({
            'modal-filter-checkbox select-all': true,
            checked: !searchFilterState[groupSelectedState] || searchFilterState[groupSelectedState].length === 0,
          })}
          onClick={handleSelectAllClick}
        >
          Select All
          <div className="cat-quantity">{totalCount}</div>
        </div>

        {/* Map over buckets and render checkboxes */}
        {buckets.map((bucket, i) => (
          <div
            key={i}
            className={classNames({
              'modal-filter-checkbox': true,
              checked: isGroupChecked(bucket.key),
            })}
            onClick={() => checkboxOnChange(bucket.key)}
          >
            {printGroup(bucket.key)}
            <div className="cat-quantity">{bucket.doc_count}</div>
          </div>
        ))}

        {buckets.length === 0 && (
          <div className="no-filters-message">
            <p>No filters available for the current search.</p>
          </div>
        )}
      </div>

      {/* Render close button */}
      <div className="event-filter-close">
        <button onClick={handleModalClose} className="button">OK</button>
      </div>
    </div>
  );
};

export default SearchFilterCheckboxes;